import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import type { SvgIconProps } from '@mui/material/SvgIcon';
import Typography from '@mui/material/Typography';
import type { ComponentType } from 'react';

export type TileViewLabel = {
  labelText: string;
  labelIconComponent: ComponentType<SvgIconProps>;
};

type TileViewHeadLabelsProps = {
  labelItems: Array<TileViewLabel>;
};

export const TileViewHeadLabels = ({ labelItems }: TileViewHeadLabelsProps) => {
  return (
    <Grid
      data-test="tile-view-labels"
      container
      sx={{
        justifyContent: 'flex-end',
        paddingRight: 5,
        alignItems: 'baseline',
      }}
    >
      {labelItems.map(({ labelText, labelIconComponent: IconComponent }) => {
        return (
          <Box
            data-test={`tile-view-label-${labelText}`}
            key={labelText}
            sx={{
              padding: 0.5,
              paddingLeft: 1.5,
              paddingRight: 1.5,
              marginTop: 1,
              marginBottom: 1,
              color: 'background.paper',
              bgcolor: theme => theme.palette.background.boxDarkest,
              borderRadius: 5,
              alignItems: 'baseline',
              display: 'flex',
            }}
          >
            <IconComponent sx={{ fill: 'white', fontSize: '14px' }} data-test={`label-icon-${labelText}`} />
            <Typography
              variant="body2Bold"
              sx={{
                marginLeft: 0.5,
              }}
            >
              {labelText}
            </Typography>
          </Box>
        );
      })}
    </Grid>
  );
};
